import { Routes, Route, Navigate } from 'react-router-dom';
import { useState } from 'react';

import Login from './pages/Login';
import Registration from './pages/Registration';
import Dashboard from './pages/Dashboard';

import Products from './pages/Products';
import ProductDetail from './pages/ProductDetail';
import AddNewProduct from './pages/AddNewProduct';

import ContainerTypes from './pages/ContainerTypes';
import ContainerDetail from './pages/ContainerDetail';
import AddNewContainer from './pages/AddNewContainer';

import Inventory from './pages/Inventory';
import InventoryDetail from './pages/InventoryDetail';

import ProtectedRoute from './components/ProtectedRoute';
import DashboardHome from './components/DashboardHome';
import Profile from './pages/Profile';
import UserManagement from './pages/UserManagement';

function App() {
  const [activeView, setActiveView] = useState('dashboard');
  const [selectedCategory, setSelectedCategory] = useState(null);

  return (
    <Routes>
      {/* Public */}
      <Route path="/login" element={<Login />} />
      <Route path="/registration" element={<Registration />} />

      {/* Protected shell */}
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <Dashboard activeView={activeView} setActiveView={setActiveView} />
          </ProtectedRoute>
        }
      >
        {/* Dashboard home */}
        <Route
          index
          element={<DashboardHome />}
        />

        {/* User profile */}
        <Route path="profile" element={<Profile />} />

        {/* User management (admin only — guard inside the page) */}
        <Route path="users" element={<UserManagement />} />

        {/* Products */}
        <Route
          path="products"
          element={
            <Products
              setActiveView={setActiveView}
              selectedCategory={selectedCategory}
              setSelectedCategory={setSelectedCategory}
            />
          }
        />
        <Route
          path="products/add"
          element={
            <AddNewProduct
              setActiveView={setActiveView}
              selectedCategory={selectedCategory}
            />
          }
        />
        <Route
          path="products/:productId"
          element={
            <ProductDetail
              setActiveView={setActiveView}
              selectedCategory={selectedCategory}
              setSelectedCategory={setSelectedCategory}
              /* NOTE: inside ProductDetail use useParams() to read :productId */
            />
          }
        />

        {/* Container Types */}
        <Route
          path="container-types"
          element={<ContainerTypes setActiveView={setActiveView} />}
        />
        <Route
          path="container-types/add"
          element={<AddNewContainer setActiveView={setActiveView} />}
        />
        <Route path="container-types/:id" element={<ContainerDetail />} />

        {/* Inventory */}
        <Route
          path="inventory"
          element={<Inventory setActiveView={setActiveView} />}
        />
        <Route
          path="inventory/:productUuid"
          element={
            <InventoryDetail
              setActiveView={setActiveView}
              /* NOTE: inside InventoryDetail use useParams() to read :productUuid */
            />
          }
        />
      </Route>

      {/* Redirects */}
      <Route path="/" element={<Navigate to="/dashboard" replace />} />
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}

export default App;